import * as React from 'react'
import Box from '@mui/material/Box'

type AlleySpacerProps = {
  children: JSX.Element | JSX.Element[]
  direction: 'top' | 'left'
  spacing: number
}

// This is a standard gutter/alley spacer, which will create margins between the components according to Admin UI standards
const AlleySpacer = (props: AlleySpacerProps) => {
  let styleObj
  const { children, direction, spacing } = props
  const marginValue = spacing * 0.5
  if (direction === 'top') {
    styleObj = {
      marginTop: `${marginValue}rem`,
      width: '100%',
    }
  } else {
    styleObj = {
      marginLeft: `${marginValue}rem`,
    }
  }
  return <Box sx={styleObj}>{children}</Box>
}

export default AlleySpacer
